import React from 'react'
import { CGE } from '../../../../common/components/CGE'

function FormsModificationSuscription({props}) {
  return (
    <>
        <div class="col-md-6">
            <CGE.FormsField
                labelName="Celular"
                idFormElement="cellphone"
                handleChange={(e) => props.setValues({ ...props.values,  newCellphone: e.target.value })}
                typeFormElement="text"
                value={props.values.newCellphone}
                maxLength="9"
                minLength="9"
                hasError={props.inputValidate?.empty?.newCellphone || props.inputValidate?.validated?.newCellphone}
                msgError={props.inputValidate?.msg?.newCellphone}
                placeholder="Ej: 912345678"
                typeElement="input-mask"
                formatChars={{
                    9: "[0-9]",
                }}
                mask="999999999"
                maskChar={null}
            />
        </div>
        <div class="col-md-6">
            <CGE.FormsField
                labelName="Nuevo Correo electrónico"
                idFormElement="email"
                handleChange={(e) => props.setValues({ ...props.values, newEmail: e.target.value })}
                typeFormElement="text"
                typeElement="input"
                value={props.values.newEmail}
                hasError={props.inputValidate?.empty?.newEmail || props.inputValidate?.validated?.newEmail}
                msgError={props.inputValidate?.msg?.newEmail}

            />
        </div>
        <div class="col-md-6 mb-1">
            <CGE.FormsField
                labelName="Confirmar Nuevo correo electrónico "
                idFormElement="emailConfirm"
                handleChange={(e) => props.setValues({ ...props.values, newEmailConfirm: e.target.value })}
                typeFormElement="text"
                typeElement="input"
                value={props.values.newEmailConfirm}
                mandatoryElement={props.values.newEmail ? true : false}
                hasError={props.inputValidate?.empty?.newEmailConfirm || props.inputValidate?.validated?.newEmailConfirm}
                msgError={props.inputValidate?.msg?.newEmailConfirm}
            />
        </div>
    </>
  )
}

export default FormsModificationSuscription